import React, { memo } from "react"
import { ScenarioNode as ScenarioNodeType } from "@features/builder/graph/types"
import NodeContainer from "./NodeContainer"

export const ScenarioNode = memo((node: ScenarioNodeType) => {
  return (
    <NodeContainer node={node}>
      <div className="graph-node-container">
        <div className="graph-node-type graph-node-scenario">{node.type}</div>
        <div className="graph-node-label">{node.data.label}</div>
      </div>
    </NodeContainer>
  )
})

ScenarioNode.displayName = "ScenarioNode"
